import React from 'react'

export default function Loading({ isHeightReq = true }) {
  return (
    <div className="text-center d-flex justify-content-center align-items-center" style={{ height: isHeightReq ? 'calc(100vh - 100px)' : '' }}>
      <div
        // className={ isHeightReq ? "spinner-grow" : "spinner-border"} 
        className="spinner-grow"
        role="status" />
    </div>
  )
}
